import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Video } from "@/models/video";

/**
 * VideoCarouselProps type definition
 * @typedef {Object} VideoCarouselProps
 * @property {video[]} videos - Array of video URLs to display in the carousel
 * @property {boolean} autoPlay - Whether the videos should autoplay or not
 * @property {function} fetchMoreVideos - Function to fetch more videos (optional)
 */
type VideoCarouselProps = {
    videos: Video[];
    autoPlay: boolean;
    fetchMoreVideos?: () => void;
};

/**
 * VideoCarousel component
 * @param {VideoCarouselProps} props - Properties passed to the component
 * @returns {JSX.Element} VideoCarousel React element
 */
const VideoCarousel: React.FC<VideoCarouselProps> = ({ videos, autoPlay = false, fetchMoreVideos }) => {
    // State to keep track of the currently active slide
    const [activeIndex, setActiveIndex] = useState(0);

    /**
     * Handler for slide change event
     * @param {SwiperClass} swiper - Swiper instance
     */
    const handleSlideChange = (swiper: SwiperClass) => {
        setActiveIndex(swiper.activeIndex);
    };

    /**
     * Handler for resize event
     * @param {SwiperClass} swiper - Swiper instance
     * @returns {void}
        */

    const handleOnResize = (swiper: SwiperClass) => {
        swiper.update();
    }


    return (
        <Swiper
            className='w-full'
            direction='horizontal'
            onResize={(swiper) => handleOnResize(swiper)}
            navigation={true}
            modules={[Navigation]}
            onSlideChange={handleSlideChange}
            onSwiper={(swiper) => handleSlideChange(swiper)}
            centeredSlides={true}
            centeredSlidesBounds={true}
            loop={true}
            pagination={{ clickable: true }}
            onReachEnd={fetchMoreVideos}
            breakpoints={
                {
                    0: {
                        slidesPerView: 1,

                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                }
            }
        >
            {videos.map((video, index) => (
                <SwiperSlide

                    key={index}>

                    <div
                        className="relative width-full pt-[177.77%]">
                        <ReactPlayer
                            key={index}
                            playing={autoPlay && activeIndex === index}
                            url={video.url}
                            muted={true}
                            width="100%"
                            height="100%"
                            controls={true}

                            config={{
                                file: {
                                    attributes: {
                                        controlsList: 'nodownload',
                                    },
                                },
                            }}
                            style={{ position: 'absolute', top: 0, left: 0, borderRadius: '1.25rem', overflow: 'hidden', width: '100%', height: '100%' }}
                        />
                    </div>

                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default VideoCarousel;